import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography, Button, CircularProgress,
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import SeedAuthenticationRepository from '../../../components/repository/SeedAuthenticationRepository';
import seedDrawerRoutes from '../../../components/route/seed-drawer-routes';
import { drawerRoutesPropTypes, dashboard3DrawersIconsPropTypes } from '../../../components/page/dashboard-3-drawers/d3d-prop-types';
import seedLogo from '../../../components/images/logo.svg';
import { seedDashboard3DrawersIcons } from '../../../components/icon/seed-icons';
import { AppState } from '../../../components/state/MyStateProvider';
import { APP_STATE_ACTION_TYPE_USER } from '../../../components/state/seed-states';
import DashboardDrawerBottomNav from '../../../components/page/dashboard-drawer-bottomnav/DashboardDrawerBottomNav';
import { MyInputText } from '../../../components/form/field';
import { FirebaseState } from '../../../components/firebase/MyFirebaseProvider';
import StatusRepository from '../../repository/StatusRepository';
import { APP_STATE_ACTION_TYPE_RAFFLESIA_USER } from '../../state/rafflesia-states';
import StatusCard from '../StatusCard';

const HomePage = (props) => {
  const {
    AuthenticationRepository,
    drawerRoutes,
    applicationName,
    logo,
    icons,
    pageUtils,
    popoverMenus,
    bottomNavMenus,
  } = props;

  const { state } = React.useContext(AppState);
  const { firebaseConfig } = React.useContext(FirebaseState);
  const userState = state[APP_STATE_ACTION_TYPE_USER];
  const { user } = userState;
  const rafflesiaUser = state[APP_STATE_ACTION_TYPE_RAFFLESIA_USER];
  let follows = ['empty'];
  if (rafflesiaUser) {
    follows = rafflesiaUser.follows;
  }

  const ref = React.useRef(null);
  const [isLoadingStatus, setIsLoadingStatus] = React.useState(false);
  const [statusRepo] = React.useState(new StatusRepository(firebaseConfig, state));

  function prepend(value, array) {
    const newArray = array.slice();
    newArray.unshift(value);
    console.log(newArray);
    return newArray;
  }

  const [data, setData] = React.useReducer((oldData, { type, value, id }) => {
    switch (type) {
      case 'add_all':
        return value;
      case 'prepend':
        return prepend(value, oldData);
      case 'append':
        return [...oldData, value];
      case 'update':
        return oldData.map((d) => (d.id === id ? value : d));
      case 'remove':
        return oldData.filter((d) => d.id !== id);
      case 'clear':
        return [];
      default:
        return oldData;
    }
  }, []);

  React.useEffect(() => {
    const unsubscribe = statusRepo.getAllFollowsLive(follows)
      .onSnapshot((snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === 'added') {
            console.log('New city: ', change.doc.data());
            const status = change.doc.data();
            setData({
              type: 'prepend',
              value: {
                id: change.doc.id,
                ...status,
              },
            });
          }
          if (change.type === 'modified') {
            console.log('Modified city: ', change.doc.data());
            const newStatus = change.doc.data();
            setData({
              type: 'update',
              id: change.doc.id,
              value: {
                id: change.doc.id,
                ...newStatus,
              },
            });
          }
          if (change.type === 'removed') {
            console.log('Removed city: ', change.doc.data());
            setData({
              type: 'remove',
              id: change.doc.id,
            });
          }
        });
      });

    return () => {
      unsubscribe();
    };
  }, [statusRepo]);

  const handleSubmitStatus = () => {
    // const status = ref.current.value;
    // if (status.trim() !== '') {
    //   setIsLoadingStatus(true);
    //   pageUtils.loadSomethingSilent(
    //     () => statusRepo.create(userId, status),
    //     (payload) => {
    //       pageUtils.showSnackbar('Status sent!', 'success');
    //     },
    //     (error) => {
    //       pageUtils.showSnackbar(error.message, 'error');
    //     },
    //     () => {
    //       setIsLoadingStatus(false);
    //     },
    //   );
    // }
  };

  return (
    <DashboardDrawerBottomNav
      titleId="rafflesia.home.title"
      routes={drawerRoutes}
      AuthenticationRepository={AuthenticationRepository}
      applicationName={applicationName}
      logo={logo}
      icons={icons}
      popoverMenus={popoverMenus}
      bottomNavMenus={bottomNavMenus}
    >
      <Typography color="textPrimary">
        <FormattedMessage
          id="rafflesia.home.text.welcome"
          values={{ applicationName }}
        />
      </Typography>
      <MyInputText
        name="Status"
        inputRef={ref}
        defaultValue=""
        disabled={isLoadingStatus}
        placeholder="Post status..."
        multiline
      />
      <Button
        onClick={handleSubmitStatus}
        variant="contained"
        color="primary"
        startIcon={!isLoadingStatus ? null : <CircularProgress size={20} />}
      >
        Post
      </Button>
      {
        data.map((status) => (
          <StatusCard
            key={`status-card-${status.id}`}
            photoURL={status.photoURL}
            username={status.username}
            timestamp={new Date(status.timestamp.seconds * 1000)}
            message={status.message}
            comments={status.comments}
          />
        ))
      }
    </DashboardDrawerBottomNav>
  );
};

HomePage.propTypes = {
  AuthenticationRepository: PropTypes.func,
  applicationName: PropTypes.string,
  logo: PropTypes.string,
  drawerRoutes: drawerRoutesPropTypes,
  icons: dashboard3DrawersIconsPropTypes,
};

HomePage.defaultProps = {
  AuthenticationRepository: SeedAuthenticationRepository,
  applicationName: 'react-seed',
  logo: seedLogo,
  drawerRoutes: seedDrawerRoutes,
  icons: seedDashboard3DrawersIcons,
};

export default HomePage;
